export default {
  setUserInfo(state, data) {
    state.userInfo = data;
  },
  setUserAddress(state, data) {
    state.userAddress = data;
  },
  setUserCart(state, data) {
    state.userCart = data;
  },
  setAddressFrom(state, data) {
    state.addressFrom = data;
  },
  setIFBindPhone(state, data) {
    if(!data) {
      state.ifBindPhone = false;
    }else{
      state.ifBindPhone = true;
    }
  }
};
